var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCrystalHero = function SvgCrystalHero(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crystal_hero_svg__hero",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 1200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient",
    cx: 141.8559,
    cy: 784.3407,
    fx: 141.8559,
    fy: 784.3407,
    r: 467.5276,
    gradientTransform: "translate(13.3391 32.229) scale(.9679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1653,
    stopColor: "#57b7c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3705,
    stopColor: "#5fa8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#6b8fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8362,
    stopColor: "#7c6ca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a509b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-2",
    cx: 400.6303,
    cy: 819.3626,
    fx: 400.6303,
    fy: 819.3626,
    r: 159.4441,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-3",
    cx: 435.6374,
    cy: 870.4505,
    fx: 435.6374,
    fy: 870.4505,
    r: 141.3233,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-4",
    cx: 351.5312,
    cy: 824.5338,
    fx: 351.5312,
    fy: 824.5338,
    r: 135.8014,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-5",
    cx: 265.2747,
    cy: 814.0997,
    fx: 265.2747,
    fy: 814.0997,
    r: 150.0409,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-6",
    cx: 352.8242,
    cy: 824.5604,
    fx: 352.8242,
    fy: 824.5604,
    r: 110.8524,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-7",
    cx: 321.1758,
    cy: 850.1429,
    fx: 321.1758,
    fy: 850.1429,
    r: 95.8963,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-8",
    cx: 242.9066,
    cy: 949.9069,
    fx: 242.9066,
    fy: 949.9069,
    r: 190.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3adbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#a2aac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#a2a1cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#a293e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#a27ffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-9",
    cx: 341.6097,
    cy: 1144.4182,
    fx: 341.6097,
    fy: 1144.4182,
    r: 223.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#5d47c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#6653c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#7567ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8a83d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9794e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-10",
    cx: 381.0649,
    cy: 773.7882,
    fx: 381.0649,
    fy: 773.7882,
    r: 192.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f85aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2373,
    stopColor: "#7f84ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#8283ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#8581ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    stopColor: "#8b7fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c7ff0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-11",
    cx: 512.63,
    cy: 1047.3594,
    fx: 512.63,
    fy: 1047.3594,
    r: 353.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b53c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2463,
    stopColor: "#7d57c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#8363ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#8d77d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#9b93df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-12",
    cx: 534.0738,
    cy: 1007.6384,
    fx: 534.0738,
    fy: 1007.6384,
    r: 172.5504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#6e4dc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#7659c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#836dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#9589db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-13",
    cx: 72.1313,
    cy: 901.9871,
    fx: 72.1313,
    fy: 901.9871,
    r: 261.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c4bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#71b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8daac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-14",
    cx: 441.2484,
    cy: 1047.4176,
    fx: 441.2484,
    fy: 1047.4176,
    r: 180.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#7b81d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#858dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#95a1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b0c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-15",
    cx: 443.6064,
    cy: 1099.6476,
    fx: 443.6064,
    fy: 1099.6476,
    r: 111.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#5d4dc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#6859c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#7a6dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#9389db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-16",
    cx: 123.277,
    cy: 814.3903,
    fx: 123.277,
    fy: 814.3903,
    r: 376.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bbdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2012,
    stopColor: "#5cb8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4052,
    stopColor: "#61acbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#6a98b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#757caa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#835c9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystal_hero_svg__linear-gradient",
    x1: 260.1728,
    y1: 415.6782,
    x2: 543.4886,
    y2: 676.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33dc8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53bcc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7026,
    stopColor: "#66add0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809be5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-17",
    cx: 385.8335,
    cy: 637.8289,
    fx: 385.8335,
    fy: 637.8289,
    r: 257.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d4ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-18",
    cx: 313.3334,
    cy: 493.7977,
    fx: 313.3334,
    fy: 493.7977,
    r: 255.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-19",
    cx: 352.3642,
    cy: 75.4417,
    fx: 352.3642,
    fy: 75.4417,
    r: 230.4185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#98f66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-20",
    cx: 434.4066,
    cy: 114.5824,
    fx: 434.4066,
    fy: 114.5824,
    r: 83.0279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#69f56e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe988"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-21",
    cx: 194.6158,
    cy: 126.275,
    fx: 194.6158,
    fy: 126.275,
    r: 296.3492,
    xlinkHref: "#crystal_hero_svg__radial-gradient-19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-22",
    cx: 551.5495,
    cy: 356.956,
    fx: 551.5495,
    fy: 356.956,
    r: 201.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6662,
    stopColor: "#3cd8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-23",
    cx: 303.1126,
    cy: 633.9066,
    fx: 303.1126,
    fy: 633.9066,
    r: 217.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d4a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-24",
    cx: 343.2035,
    cy: 657.0021,
    fx: 343.2035,
    fy: 657.0021,
    r: 230.9947,
    xlinkHref: "#crystal_hero_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-25",
    cx: 114.189,
    cy: 376.5303,
    fx: 114.189,
    fy: 376.5303,
    r: 265.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#9ff476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-26",
    cx: 89.9391,
    cy: 249.3946,
    fx: 89.9391,
    fy: 249.3946,
    r: 304.2782,
    xlinkHref: "#crystal_hero_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-27",
    cx: 402.6699,
    cy: 470.9559,
    fx: 402.6699,
    fy: 470.9559,
    r: 141.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b56c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-28",
    cx: 515.022,
    cy: 378.8462,
    fx: 515.022,
    fy: 378.8462,
    r: 197.7039,
    xlinkHref: "#crystal_hero_svg__radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-29",
    cx: 152.2571,
    cy: 790.5559,
    fx: 152.2571,
    fy: 790.5559,
    r: 272.5343,
    xlinkHref: "#crystal_hero_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-30",
    cx: 125.5099,
    cy: 676.0495,
    fx: 125.5099,
    fy: 676.0495,
    r: 199.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe47d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc2bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-31",
    cx: 467.6374,
    cy: 268.0769,
    fx: 467.6374,
    fy: 268.0769,
    r: 94.6049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d7a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-32",
    cx: 607.4062,
    cy: 417.8346,
    fx: 607.4062,
    fy: 417.8346,
    r: 261.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-33",
    cx: 460.9625,
    cy: 470.5482,
    fx: 460.9625,
    fy: 470.5482,
    r: 171.8521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#4ec1c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#52b5cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#59a1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6385f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-34",
    cx: 472.5153,
    cy: 864.7858,
    fx: 472.5153,
    fy: 864.7858,
    r: 489.5842,
    gradientTransform: "translate(-167.3934 1122.6465) rotate(-68.7204) scale(1 .5813)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2705,
    stopColor: "#4fc1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#56b5c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    stopColor: "#62a1cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d90d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-35",
    cx: 486.2336,
    cy: 563.6076,
    fx: 486.2336,
    fy: 563.6076,
    r: 268.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#51c2c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#5db8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#71a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    stopColor: "#8d8fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-36",
    cx: 505.399,
    cy: 501.0495,
    fx: 505.399,
    fy: 501.0495,
    r: 162.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3da6c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    stopColor: "#69c0ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83cfa3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-37",
    cx: 542.8262,
    cy: 683.7978,
    fx: 542.8262,
    fy: 683.7978,
    r: 293.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#23bda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7629,
    stopColor: "#64cd98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed493"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-38",
    cx: 580.2022,
    cy: 401.5107,
    fx: 580.2022,
    fy: 401.5107,
    r: 147.9075,
    gradientTransform: "translate(.5142 -.4726) rotate(.0305)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#82ca9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-39",
    cx: 544.2031,
    cy: 524.2366,
    fx: 544.2031,
    fy: 524.2366,
    r: 249.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#60c4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#a1e0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbeb99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-40",
    cx: 323.078,
    cy: 280.5016,
    fx: 323.078,
    fy: 280.5016,
    r: 173.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4002,
    stopColor: "#45cbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    stopColor: "#85dfb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fe8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-41",
    cx: 130.1882,
    cy: 770.2907,
    fx: 130.1882,
    fy: 770.2907,
    r: 247.6438,
    xlinkHref: "#crystal_hero_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-42",
    cx: 444.4011,
    cy: 998.267,
    fx: 444.4011,
    fy: 998.267,
    r: 195.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#6d7cd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#7688d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#849ccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-43",
    cx: 616.9294,
    cy: 911.5336,
    fx: 616.9294,
    fy: 911.5336,
    r: 198.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7149c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#724dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#7659ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#7c6dd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#8589e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#90aefc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92b2ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-44",
    cx: 490.2038,
    cy: 748.754,
    fx: 490.2038,
    fy: 748.754,
    r: 176.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6e473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fbfc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-45",
    cx: 428.3634,
    cy: 692.1914,
    fx: 428.3634,
    fy: 692.1914,
    r: 45.5138,
    xlinkHref: "#crystal_hero_svg__radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-46",
    cx: 324.6572,
    cy: 642.1938,
    fx: 324.6572,
    fy: 642.1938,
    r: 286.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76eaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7388ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-47",
    cx: 308.2581,
    cy: 698.0922,
    fx: 308.2581,
    fy: 698.0922,
    r: 184.2543,
    xlinkHref: "#crystal_hero_svg__radial-gradient-46"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-48",
    cx: 355.5856,
    cy: 762.3335,
    fx: 355.5856,
    fy: 762.3335,
    r: 199.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#4ec3c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#53bbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#5aaee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#659bfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-49",
    cx: 148.9862,
    cy: 725.9264,
    fx: 148.9862,
    fy: 725.9264,
    r: 317.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dafd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51aed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dacd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#71a9cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8da5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-50",
    cx: 405.6319,
    cy: 712.4451,
    fx: 405.6319,
    fy: 712.4451,
    r: 269.6183,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-51",
    cx: 307.5352,
    cy: 672.284,
    fx: 307.5352,
    fy: 672.284,
    r: 199.0771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#76c1c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#73b5cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#6ea1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6785f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-52",
    cx: 221.095,
    cy: 765.2777,
    fx: 221.095,
    fy: 765.2777,
    r: 85.8599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#51c3be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#5ebdc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73b3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-53",
    cx: 218.0434,
    cy: 538.7192,
    fx: 218.0434,
    fy: 538.7192,
    r: 345.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96e46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#6fbbd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-54",
    cx: 165.3956,
    cy: 715.1099,
    fx: 165.3956,
    fy: 715.1099,
    r: 177.4849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96e46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fbbd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-55",
    cx: 135.3628,
    cy: 550.9149,
    fx: 135.3628,
    fy: 550.9149,
    r: 177.5713,
    xlinkHref: "#crystal_hero_svg__radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-56",
    cx: 329.5881,
    cy: 689.7124,
    fx: 329.5881,
    fy: 689.7124,
    r: 102.8368,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-57",
    cx: 521.0769,
    cy: 569.5275,
    fx: 521.0769,
    fy: 569.5275,
    r: 250.3397,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-58",
    cx: 417,
    cy: 608.1596,
    fx: 417,
    fy: 608.1596,
    r: 262.9409,
    xlinkHref: "#crystal_hero_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystal_hero_svg__linear-gradient-2",
    x1: 138.5428,
    y1: 687.15,
    x2: 260.9601,
    y2: 898.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67c6a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cc2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8067,
    stopColor: "#7bacc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95a1cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-59",
    cx: 111.6957,
    cy: 650.2582,
    fx: 111.6957,
    fy: 650.2582,
    r: 154.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0289,
    stopColor: "#00aca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#29d19f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-60",
    cx: 70.5419,
    cy: 722.2195,
    fx: 70.5419,
    fy: 722.2195,
    r: 265.4047,
    xlinkHref: "#crystal_hero_svg__radial-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-61",
    cx: 162.5434,
    cy: 994.1154,
    fx: 162.5434,
    fy: 994.1154,
    r: 120.1059,
    xlinkHref: "#crystal_hero_svg__radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-62",
    cx: 166.4787,
    cy: 926.2649,
    fx: 166.4787,
    fy: 926.2649,
    r: 148.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2762,
    stopColor: "#26bbbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#67c6c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81cbc5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-63",
    cx: 98.4892,
    cy: 771.2825,
    fx: 98.4892,
    fy: 771.2825,
    r: 98.6866,
    xlinkHref: "#crystal_hero_svg__radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-64",
    cx: 169.1699,
    cy: 878.422,
    fx: 169.1699,
    fy: 878.422,
    r: 200.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#82ca9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-65",
    cx: 275.1505,
    cy: 852.2802,
    fx: 275.1505,
    fy: 852.2802,
    r: 139.6287,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-66",
    cx: 330.6327,
    cy: 849.8113,
    fx: 330.6327,
    fy: 849.8113,
    r: 104.9169,
    xlinkHref: "#crystal_hero_svg__radial-gradient-14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-67",
    cx: 260.8407,
    cy: 834.1064,
    fx: 260.8407,
    fy: 834.1064,
    r: 214.7103,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-68",
    cx: 190.7143,
    cy: 850.6487,
    fx: 190.7143,
    fy: 850.6487,
    r: 71.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2762,
    stopColor: "#26b0b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#67a9c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81a7c5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-69",
    cx: 256.7446,
    cy: 696.2889,
    fx: 256.7446,
    fy: 696.2889,
    r: 160.5164,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-70",
    cx: 128.6484,
    cy: 481.967,
    fx: 128.6484,
    fy: 481.967,
    r: 225.15,
    gradientTransform: "translate(8.8983 17.697) scale(.9492 .9697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e69a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4491,
    stopColor: "#28d4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fc1b6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-71",
    cx: 258.467,
    cy: 688.8597,
    fx: 258.467,
    fy: 688.8597,
    r: 193.2267,
    xlinkHref: "#crystal_hero_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-72",
    cx: 70.1646,
    cy: 476.9477,
    fx: 70.1646,
    fy: 476.9477,
    r: 240.8936,
    xlinkHref: "#crystal_hero_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-73",
    cx: 214.4505,
    cy: 706.7547,
    fx: 214.4505,
    fy: 706.7547,
    r: 189.5396,
    xlinkHref: "#crystal_hero_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-74",
    cx: 285.6798,
    cy: 608.353,
    fx: 285.6798,
    fy: 608.353,
    r: 134.4332,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_hero_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-75",
    cx: 201.3232,
    cy: 677.8845,
    fx: 201.3232,
    fy: 677.8845,
    r: 146.7358,
    xlinkHref: "#crystal_hero_svg__radial-gradient-59"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-76",
    cx: 160.1484,
    cy: 641.2363,
    fx: 160.1484,
    fy: 641.2363,
    r: 55.8405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-77",
    cx: 108.8681,
    cy: 561.4835,
    fx: 108.8681,
    fy: 561.4835,
    r: 70.2318,
    gradientTransform: "translate(8.2051 27.5769) scale(.9359 .9538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32db9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13c4b4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-78",
    cx: 71.6342,
    cy: 637.4954,
    fx: 71.6342,
    fy: 637.4954,
    r: 247.6768,
    xlinkHref: "#crystal_hero_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-79",
    cx: 195.2426,
    cy: 680.7302,
    fx: 195.2426,
    fy: 680.7302,
    r: 164.0688,
    xlinkHref: "#crystal_hero_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-80",
    cx: 135.9319,
    cy: 633.7543,
    fx: 135.9319,
    fy: 633.7543,
    r: 97.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00abbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#29d0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_hero_svg__radial-gradient-81",
    cx: 141.8918,
    cy: 638.956,
    fx: 141.8918,
    fy: 638.956,
    r: 86.4765,
    xlinkHref: "#crystal_hero_svg__radial-gradient-18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__lower"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.5631,814.472c-24.521,16.7393-49.042,33.4787-73.5631,50.2181,9.0341,36.3759,18.0681,72.7518,27.1022,109.1277,19.0247,23.0652,38.3818,46.2467,58.0761,69.5327,14.8708,17.5828,29.7142,34.9656,44.525,52.1495,26.4569-28.972,52.9138-57.9439,79.3707-86.9159,10.002-22.8557,20.004-45.7113,30.006-68.567,16.9734-48.5675,33.9467-97.1351,50.9201-145.7026-34.7188-2.9382-69.4377-5.8764-104.1565-8.8145-37.4268,9.6573-74.8536,19.3146-112.2804,28.972Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__shapes_shard_01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459,780c.3333,6.6667,.6667,13.3333,1,20,4.6667,23.6667,9.3333,47.3333,14,71,2,5.6667,4,11.3333,6,17l78-87c2.6667-4,5.3333-8,8-12-35.6667-3-71.3333-6-107-9Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,809c1.6667,2.6667,3.3333,5.3333,5,8,17.3333,17.6667,34.6667,35.3333,52,53,19-27.6667,38-55.3333,57-83,1-2.3333,2-4.6667,3-7-39,9.6667-78,19.3333-117,29Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,780c-20,29.3333-40,58.6667-60,88,27,6.6667,54,13.3333,81,20l-21-108Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,809c-25.3333,18-50.6667,36-76,54,32.3333,20.3333,64.6667,40.6667,97,61-.3333-7.3333-.6667-14.6667-1-22-6-29.3333-12-58.6667-18-88-.6667-1.6667-1.3333-3.3333-2-5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,868c27,6.6667,54,13.3333,81,20l-117,36c1-2.6667,2-5.3333,3-8l24-39,9-9Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,809c19,19.6667,38,39.3333,57,59-12,18.6667-24,37.3333-36,56-4.6667-14-9.3333-28-14-42-2.3333-24.3333-4.6667-48.6667-7-73Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,975h-2c35.1667,42.1667,70.3333,84.3333,105.5,126.5,.1667-3.1667,.3333-6.3333,.5-9.5-3-27-6-54-9-81-31.6667-12-63.3333-24-95-36Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5,922.5c-.1667,1.5-.3333,3-.5,4.5,7.3333,27.3333,14.6667,54.6667,22,82,1.3333,1.6667,2.6667,3.3333,4,5,29.3333-.6667,58.6667-1.3333,88-2,1.3333-.3333,2.6667-.6667,4-1,.6667-2.3333,1.3333-4.6667,2-7,3.3333-18.6667,6.6667-37.3333,10-56-40.6667-8.3333-81.3333-16.6667-122-25-2.5-.1667-5-.3333-7.5-.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,886c.6667,1.3333,1.3333,2.6667,2,4,3.6667,19.3333,7.3333,38.6667,11,58-.1667,.8333-.3333,1.6667-.5,2.5-42.3285-9.3064-84.6569-18.6128-126.9854-27.9193,38.1618-12.1936,76.3236-24.3872,114.4854-36.5807Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,940h-1c-6,2.6667-12,5.3333-18,8-.8333,.8333-1.6667,1.6667-2.5,2.5-3.1667,20.1667-6.3333,40.3333-9.5,60.5,10.3333-23.6667,20.6667-47.3333,31-71Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,886c4.1667,21.5,8.3333,43,12.5,64.5,7.1667-3.5,14.3333-7,21.5-10.5,17.6667-50.3333,35.3333-100.6667,53-151-29,32.3333-58,64.6667-87,97Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,863c32.8333,19.8333,65.6667,39.6667,98.5,59.5-2.5,2.8333-5,5.6667-7.5,8.5-19.3333,14-38.6667,28-58,42-1.6667,.6667-3.3333,1.3333-5,2l-28-112Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,1012.5l-94.5-37.5,70.5-52.5,24,90Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,1012.5c3.6667,29.6666,7.3333,59.3334,11,89,27.5-30.1667,55-60.3333,82.5-90.5-31.1667,.5-62.3333,1-93.5,1.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,863c32.8333,19.8333,65.6667,39.6667,98.5,59.5,38.1667-12.1667,76.3333-24.3333,114.5-36.5,29-32.3333,58-64.6667,87-97-35.6667-3-71.3333-6-107-9-39,9.6667-78,19.3333-117,29-25.3333,18-50.6667,36-76,54Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-16)",
      opacity: 0.88
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490,949c-2.6667-15.3333-5.3333-30.6667-8-46,3.3333,15.3333,6.6667,30.6667,10,46,5.6667-2.3333,11.3333-4.6667,17-7-5.6667,3-11.3333,6-17,9-2,12.3333-4,24.6667-6,37,1.3333-12.3333,2.6667-24.6667,4-37-14.6667-3.3333-29.3333-6.6667-44-10,14.6667,2.6667,29.3333,5.3333,44,8Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,932c4,13.6667,8,27.3333,12,41,15-10.6667,30-21.3333,45-32-14.3333,11.3333-28.6667,22.6667-43,34,15.6667,6.6667,31.3333,13.3333,47,20-15.6667-6-31.3333-12-47-18,19.542,23.8239,29.2095,35.825,29,36-.2155,.18-10.8808-12.1517-32-37-3.6667-14.6667-7.3333-29.3333-11-44Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__bg-2",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.5,659.8479c-19.2151-49.5824-38.43-99.1648-57.6451-148.7473-8.4677-33.9248-16.9353-67.8496-25.4029-101.7744-25.0773-76.0046-50.1545-152.0092-75.2317-228.0139-14.9812-9.786-29.9624-19.572-44.9436-29.358-10.096-11.417-20.192-22.834-30.2881-34.251-14.3298,14.0266-28.6597,28.0532-42.9896,42.0798-28.9853,52.5182-57.9708,105.0364-86.9562,157.5547-5.8622,16.9624-11.7244,33.9248-17.5866,50.8872-28.9854,43.3846-57.9708,86.7692-86.9562,130.1539,7.1649,40.775,14.3299,81.55,21.4948,122.3251-2.9311,6.1978-5.8622,12.3956-8.7933,18.5934,5.5365,22.5078,11.0731,45.0156,16.6096,67.5234,12.3758,24.7912,24.7516,49.5824,37.1273,74.3736,12.3758,25.1174,24.7516,50.2348,37.1273,75.3522,31.827,19.0522,63.654,38.1044,95.4811,57.1567l112.3483-36.1329,84.8972-94.2942c.128-.3678,.256-.7354,.384-1.1032,23.7745-40.775,47.5491-81.55,71.3236-122.3251Z",
    style: {
      fill: "url(#crystal_hero_svg__linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__shapes_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5,498.5c1.5,1.1667,3,2.3333,4.5,3.5,24,32.3333,48,64.6667,72,97l-9,93c-14.6667-22-29.3333-44-44-66-.3333-1-.6667-2-1-3l-22.5-124.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,341c-17.3333,28.3333-34.6667,56.6667-52,85-.6667,.6667-1.3333,1.3333-2,2,3.6667-29,7.3333-58,11-87h43Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,143.5c.3225,.9677,.5,1.5,.5,1.5,0,.0004-10.2095,48.2632-11,52-12.3333,15-24.6667,30-37,45-1-.6667-2-1.3333-3-2-8.3333-28.6667-16.6667-57.3333-25-86,.1667-.8333,.3333-1.6667,.5-2.5,14.6667-14.3333,29.3333-28.6667,44-43,10.3333,11.6667,20.6667,23.3333,31,35Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,173.5c-2.1667,1.5-4.3333,3-6.5,4.5-13.6667,5.3333-27.3333,10.6667-41,16-3.1667,.8333-6.3333,1.6667-9.5,2.5,3.6667-17.6667,7.3333-35.3333,11-53,15.3333,10,30.6667,20,46,30Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.5,240.5c.5,1.1667,1,2.3333,1.5,3.5,3,16.3333,6,32.6667,9,49-.3333,15.6667-.6667,31.3333-1,47l-9,6c-23.3333,7-46.6667,14-70,21-15.3333-16.6667-30.6667-33.3333-46-50-.5-1.1667-1-2.3333-1.5-3.5l90-162c9,29.6667,18,59.3333,27,89Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,294c19.3333,7.3333,38.6667,14.6667,58,22-1.6667-23.6667-3.3333-47.3333-5-71-7.3333-15.3333-14.6667-30.6667-22-46-.8333-.8333-1.6667-1.6667-2.5-2.5-12.3333,14.6667-24.6667,29.3333-37,44,2.8333,17.8333,5.6667,35.6667,8.5,53.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,498.5l4.5-1.5c20.3333-4.6667,40.6667-9.3333,61-14,1.5,.1667,3,.3333,4.5,.5,1.1667,2.1667,2.3333,4.3333,3.5,6.5,1,34.6667,2,69.3333,3,104-.6667,2-1.3333,4-2,6-24.8333-33.8333-49.6667-67.6667-74.5-101.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,483.5c.5-1.1667,1-2.3333,1.5-3.5,20-22.3333,40-44.6667,60-67,12,29.6667,24,59.3333,36,89,.3333,3.3333,.6667,6.6667,1,10-.6667,1-1.3333,2-2,3l-90,84c-.6667,.3333-1.3333,.6667-2,1-1.5-38.8333-3-77.6667-4.5-116.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,364c1,.3333,2,.6667,3,1,11.6667,15.6667,23.3333,31.3333,35,47l3,6c-20.1667,21.8333-40.3333,43.6667-60.5,65.5-23.3333,5-46.6667,10-70,15,29.8333-44.8333,59.6667-89.6667,89.5-134.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,313.5c16.1667,17.1667,32.3333,34.3333,48.5,51.5,.3333,1.3333,.6667,2.6667,1,4-7.6667,15.6667-15.3333,31.3333-23,47-1,.6667-2,1.3333-3,2-13.6667-18-27.3333-36-41-54,5.8333-16.8333,11.6667-33.6667,17.5-50.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,365c.6667,1.6667,1.3333,3.3333,2,5,18.6667,18,37.3333,36,56,54,1.6667,.6667,3.3333,1.3333,5,2,3.8333-27.8333,7.6667-55.6667,11.5-83.5-24.8333,7.5-49.6667,15-74.5,22.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,293c18.6667,6,37.3333,12,56,18-.3333,1.3333-.6667,2.6667-1,4-4.6667,7.6667-9.3333,15.3333-14,23-1.3333,1.3333-2.6667,2.6667-4,4-13.1667,.1667-26.3333,.3333-39.5,.5,.8333-16.5,1.6667-33,2.5-49.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,641.5c2.1667,1.1667,4.3333,2.3333,6.5,3.5,14,12.6667,28,25.3333,42,38l3,3c3.6667,4.6667,7.3333,9.3333,11,14,1.3333,2.3333,2.6667,4.6667,4,7l-4,2c-12.6667,.6667-25.3333,1.3333-38,2-2.5-.1667-5-.3333-7.5-.5-5.6667-23-11.3333-46-17-69Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,623c14.3333,21,28.6667,42,43,63-17.1667-14.8333-34.3333-29.6667-51.5-44.5,2.8333-6.1667,5.6667-12.3333,8.5-18.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,173.5c-.5,1.8333-1,3.6667-1.5,5.5-9,19.3333-18,38.6667-27,58-1.8333,3.1667-3.6667,6.3333-5.5,9.5-7.6667-16.6667-15.3333-33.3333-23-50,19-7.6667,38-15.3333,57-23Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,173.5c-11.3333,24.3333-22.6667,48.6667-34,73l4.5,64.5,6,9c33.3333,28.6667,66.6667,57.3333,100,86l-76.5-232.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531,384c.3333,2.6667,.6667,5.3333,1,8,13,33.6667,26,67.3333,39,101,2.5,5.8333,5,11.6667,7.5,17.5-8.1667-34.8333-16.3333-69.6667-24.5-104.5-7.6667-7.3333-15.3333-14.6667-23-22Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531,384c35.8333,92.8333,71.6667,185.6667,107.5,278.5-2.1667,1.8333-4.3333,3.6667-6.5,5.5l-117,51c-12.3333-20-24.6667-40-37-60-2.3333-5.3333-4.6667-10.6667-7-16l-1.5-7.5c-.8333-45.1667-1.6667-90.3333-2.5-135.5,19.6667-36.3333,39.3333-72.6667,59-109,1.6667-2.3333,3.3333-4.6667,5-7Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,716l-2,2c-3.6667,14-7.3333,28-11,42,19.3333,9.6667,38.6667,19.3333,58,29h5c24.1667-42.1667,48.3333-84.3333,72.5-126.5-40.8333,17.8333-81.6667,35.6667-122.5,53.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,500c-2,2.6667-4,5.3333-6,8-9,27.3333-18,54.6667-27,82,11.6667,17.3333,23.3333,34.6667,35,52,.3333,.3333,.6667,.6667,1,1-1-47.6667-2-95.3333-3-143Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,425c-16.3333,29-32.6667,58-49,87,20.6667,42.3333,41.3333,84.6667,62,127,15.6667-16,31.3333-32,47-48,10.3333-30.3333,20.6667-60.6667,31-91-.0843-.7027-.1685-1.4055-.2528-2.1082-29.2491-23.6306-58.4981-47.2612-87.7472-70.8918-1-.6667-2-1.3333-3-2Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,311c.6667,3.3333,1.3333,6.6667,2,10,10,31.6667,20,63.3333,30,95l3,6h1c14.6667-11.6667,29.3333-23.3333,44-35l3-3c-27.6667-24.3333-55.3333-48.6667-83-73Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,422c-.3333,.3333-.6667,.6667-1,1-4.3333,22-8.6667,44-13,66-.3333,3.6667-.6667,7.3333-1,11,21-38.6667,42-77.3333,63-116-16,12.6667-32,25.3333-48,38Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,311c11.6667,37,23.3333,74,35,111-2.3333,1-4.6667,2-7,3-30.3333,.6667-60.6667,1.3333-91,2-2.3333-.3333-4.6667-.6667-7-1,23.3333-38.3333,46.6667-76.6667,70-115Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,706.5c.8333,.5,1.6667,1,2.5,1.5l24,90c.6667,20,1.3333,40,2,60-.3333,1.6667-.6667,3.3333-1,5-25.1667-50.8333-50.3333-101.6667-75.5-152.5,16-1.3333,32-2.6667,48-4Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,813c.3333,23.3333,.6667,46.6667,1,70l-1,4-114,36v-8c5.6667-39.6667,11.3333-79.3333,17-119,32.3333,5.6667,64.6667,11.3333,97,17Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.5,758.5c20.5,10.1667,41,20.3333,61.5,30.5-29,32.6667-58,65.3333-87,98-.5-24.1667-1-48.3333-1.5-72.5-.1667-1.5-.3333-3-.5-4.5,7.3333-15.3333,14.6667-30.6667,22-46,1.8333-1.8333,3.6667-3.6667,5.5-5.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5,588.5c-15.5,16.1667-31,32.3333-46.5,48.5-.3333,1-.6667,2-1,3,.3333,3.6667,.6667,7.3333,1,11h1c25.6667-2.3333,51.3333-4.6667,77-7l2-1c-11.1667-18.1667-22.3333-36.3333-33.5-54.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,653l21-3c-.3333-4.3333-.6667-8.6667-1-13-1.3333,.6667-2.6667,1.3333-4,2-3.6667,3-7.3333,6-11,9-1.6667,1.6667-3.3333,3.3333-5,5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,643c-26.3333,2.3333-52.6667,4.6667-79,7-.3333,1-.6667,2-1,3-4.3333,27.3333-8.6667,54.6667-13,82,.6667,19.3333,1.3333,38.6667,2,58,.8333,1.8333,1.6667,3.6667,2.5,5.5,31.6667,5.3333,63.3333,10.6667,95,16,9-18.6667,18-37.3333,27-56-.8333-6.1667-1.6667-12.3333-2.5-18.5l-24-81c-2.3333-5.3333-4.6667-10.6667-7-16Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,650c-6,.3333-12,.6667-18,1l-1,2c1.6667,26,3.3333,52,5,78,.3333,3,.6667,6,1,9,4.3333-30,8.6667-60,13-90Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,643c11.1667,38.5,22.3333,77,33.5,115.5,3.8333-14.1667,7.6667-28.3333,11.5-42.5-15-24.3333-30-48.6667-45-73Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,857c-.3333,2-.6667,4-1,6l99,60c5.9445-41.3955,11.8889-82.7909,17.8334-124.1864-2.2778-.2712-4.5556-.5424-6.8334-.8136-30.6667,3-61.3333,6-92,9-5.6667,16.6667-11.3333,33.3333-17,50Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,512l3,12c13.6667,41.3333,27.3333,82.6667,41,124,.6667,1,1.3333,2,2,3,5.6667-4.6667,11.3333-9.3333,17-14-21-41.6667-42-83.3333-63-125Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,735c1,21.3333,2,42.6667,3,64-32.1667,3.1667-64.3333,6.3333-96.5,9.5-.1667-.8333-.3333-1.6667-.5-2.5,7.3333-19.3333,14.6667-38.6667,22-58,22.3333-5.3333,44.6667-10.6667,67-16,1.6667,1,3.3333,2,5,3Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,752c-1.3333,1-2.6667,2-4,3-12,12.3333-24,24.6667-36,37-1.5,2.1667-3,4.3333-4.5,6.5,.8333,21.5,1.6667,43,2.5,64.5l42-111Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,512c-.6667,1-1.3333,2-2,3-14.6667,52.6667-29.3333,105.3333-44,158l21,72,4.5,7.5c24.1667-5.8333,48.3333-11.6667,72.5-17.5l-6-84c-15.3333-46.3333-30.6667-92.6667-46-139Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,669.5c-2.1667,.1667-4.3333,.3333-6.5,.5-12.3333,10.3333-24.6667,20.6667-37,31-.8333,1.8333-1.6667,3.6667-2.5,5.5,8.3333,30.6667,16.6667,61.3333,25,92,14.6667-15.3333,29.3333-30.6667,44-46-7.6667-27.6667-15.3333-55.3333-23-83Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,600c.3333,1.3333,.6667,2.6667,1,4,15.6667,21.3333,31.3333,42.6667,47,64,.8333,.5,1.6667,1,2.5,1.5l43.5-157.5c-31.3333,29.3333-62.6667,58.6667-94,88Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,600c16.8333,23.1667,33.6667,46.3333,50.5,69.5-15.3333,12.3333-30.6667,24.6667-46,37-4.5-6.8333-9-13.6667-13.5-20.5,3-28.6667,6-57.3333,9-86Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,426c35-1.3333,70-2.6667,105-4l-15,78c-30-24.6667-60-49.3333-90-74Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,365c21,20.3333,42,40.6667,63,61-16.6667,28.6667-33.3333,57.3333-50,86-12.6667-31.3333-25.3333-62.6667-38-94,8.3333-17.6667,16.6667-35.3333,25-53Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__highlights-2",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332,360c-.1429-.4572,18.5213-6.7898,56-19,1.3333-14,2.6667-28,4-42-.3333,14-.6667,28-1,42,9,.3333,18,.6667,27,1-9.3333,.6667-18.6667,1.3333-28,2-7.6722,52.7089-11.6727,79.0456-12,79-.3267-.0455,3.0062-26.3755,10-79-37.1891,11.1198-55.8582,16.4538-56,16Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,425c24.1007-1.3372,48.2014-2.6745,72.3022-4.0118-7.1007-23.9961-14.2014-47.9922-21.3022-71.9882,8.1007,23.9961,16.2014,47.9922,24.3022,71.9882,8.5659-6.6628,17.1319-13.3255,25.6978-19.9882-8.8993,7.6628-17.7986,15.3255-26.6978,22.9882-5.8757,36.06-8.9761,54.0619-9.3022,54.0118-.3252-.05,2.1092-18.0558,7.3022-54.0118-24.1007,.3372-48.2014,.6745-72.3022,1.0118Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,669c9.6667,15,19.3333,30,29,45,14-5.3333,28-10.6667,42-16-13.6667,6-27.3333,12-41,18-4,13.3333-8,26.6667-12,40,3-13.3333,6-26.6667,9-40-9-15.6667-18-31.3333-27-47Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,154c10,6.3333,20,12.6667,30,19,5.3333,15,10.6667,30,16,45-5.6667-14-11.3333-28-17-42-8.3333,18-16.6667,36-25,54,8-18.3333,16-36.6667,24-55-13.6667,5-27.3333,10-41,15,13.6667-5.6667,27.3333-11.3333,41-17-9.3333-6.3333-18.6667-12.6667-28-19Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612,594c8,22.6667,16,45.3333,24,68-13,6.3333-26,12.6667-39,19,12.6667-5.3333,25.3333-10.6667,38-16-18.3542,33.1301-27.3551,49.7982-27,50,.3665,.2083,10.6989-17.1235,31-52l-27-69Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,532c-6.6667,18.6667-13.3333,37.3333-20,56-9.3333,10-18.6667,20-28,30,9.3333-9.3333,18.6667-18.6667,28-28,9.1407,13.4594,13.8078,20.1266,14,20,.1934-.1274-4.1396-7.1267-13-21,6.3333-19,12.6667-38,19-57Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,456c-10.3333,18.6667-20.6667,37.3333-31,56,4.6667,10.6667,9.3333,21.3333,14,32-5.6667-11-11.3333-22-17-33,11.3333-18.3333,22.6667-36.6667,34-55Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,766c.6667,10.3333,1.3333,20.6667,2,31,18.6667,3.6667,37.3333,7.3333,56,11-19.3333-3-38.6667-6-58-9v-33Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,668c3-9.6667,6-19.3333,9-29-2.6667,10.3333-5.3333,20.6667-8,31,3.6667,13.3333,7.3333,26.6667,11,40l-12-39c-8.3333,6.3333-16.6667,12.6667-25,19,8-6.6667,16-13.3333,24-20-7.3333-11-14.6667-22-22-33,7.6667,10.3333,15.3333,20.6667,23,31Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__lower-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__bg-3",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.1148,708.5074c8.7049,29.1098,17.4098,58.2196,26.1148,87.3294,.3224,21.9941,.6448,43.9881,.9672,65.9822,1.9344,8.4095,3.8689,16.819,5.8033,25.2285-20.9563,22.3175-41.9126,44.635-62.8689,66.9525-5.1585-20.0534-10.3169-40.1068-15.4754-60.1602-8.3825-25.2285-16.765-50.457-25.1475-75.6855-3.8172-30.989-7.1034-63.3605-9.6721-97.0326-2.2951-30.0852-3.8659-59.2214-4.8361-87.3294,4.1913-2.2641,8.3825-4.5282,12.5738-6.7923,19.9891,21.0237,39.9781,42.0475,59.9672,63.0712,4.1913,6.1454,8.3825,12.2908,12.5738,18.4362Z",
    style: {
      fill: "url(#crystal_hero_svg__linear-gradient-2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__shapes_shard_03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163,622c-4.6667,2.6667-9.3333,5.3333-14,8,2,29.3333,4,58.6667,6,88,7-25.3333,14-50.6667,21-76-4.3333-6.6667-8.6667-13.3333-13-20Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,686c4.6667,6.6667,9.3333,13.3333,14,20l-3,9c-15.6667,32.3333-31.3333,64.6667-47,97,10.3333-39,20.6667-78,31-117,1.6667-3,3.3333-6,5-9Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,907c-1,1.6667-2,3.3333-3,5-5,14.3333-10,28.6667-15,43-.3333,1.6667-.6667,3.3333-1,5,22.3333-23.3333,44.6667-46.6667,67-70-16,5.6667-32,11.3333-48,17Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,829c5.3333,23,10.6667,46,16,69,.3333,3,.6667,6,1,9-6.3333,17.6667-12.6667,35.3333-19,53-5-20.3333-10-40.6667-15-61,.6667-4,1.3333-8,2-12,5-19.3333,10-38.6667,15-58Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,718l2,1c11.3333,29.3333,22.6667,58.6667,34,88,.3333,3,.6667,6,1,9v76c-.3333,2.3333-.6667,4.6667-1,7-8.5-26.8333-17-53.6667-25.5-80.5l-10.5-100.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5,807.5c1.5,1.1667,3,2.3333,4.5,3.5,4.3333,6.3333,8.6667,12.6667,13,19v2c-5.6667,22.3333-11.3333,44.6667-17,67-.1667-30.5-.3333-61-.5-91.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,832c-5.8333-8.1667-11.6667-16.3333-17.5-24.5,16.1667-33.8333,32.3333-67.6667,48.5-101.5,8.6667,30.3333,17.3333,60.6667,26,91l-4,4c-16,9.6667-32,19.3333-48,29-1.6667,.6667-3.3333,1.3333-5,2Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,797c-3,5.6667-6,11.3333-9,17-9.3333,27-18.6667,54-28,81-.9818,4.1091-1.9636,8.2181-2.9454,12.3272,15.9818-5.7757,31.9636-11.5515,47.9454-17.3272-2.1905-9.1098-4.3811-18.2196-6.5716-27.3293-.4761-21.8902-.9523-43.7804-1.4284-65.6707Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,642c-6,25.3333-12,50.6667-18,76,11.8333,29.8333,23.6667,59.6667,35.5,89.5l34.5-121.5c-4.343-4.6109-9.0036-9.2941-14-14-11.621-10.9453-23.13-20.197-34-28-1.3333-.6667-2.6667-1.3333-4-2Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,832c5.6667,25.3333,11.3333,50.6667,17,76,13.3333-37,26.6667-74,40-111-19,11.6667-38,23.3333-57,35Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,622c20.6667,21.3333,41.3333,42.6667,62,64-17.3333-14.6667-34.6667-29.3333-52-44-3.3333-6.6667-6.6667-13.3333-10-20Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__highlights-3",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167,818c4,15.3333,8,30.6667,12,46-5-14.6667-10-29.3333-15-44-1.6667-20.3333-3.3333-40.6667-5-61,2.6667,19.6667,5.3333,39.3333,8,59Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,846c4.3333,20.6667,8.6667,41.3333,13,62-2.6667,8-5.3333,16-8,24,3.3333-8,6.6667-16,10-24,9-3.6667,18-7.3333,27-11-8.6667,3-17.3333,6-26,9,10-29.6667,20-59.3333,30-89-10.6667,29.6667-21.3333,59.3333-32,89-4.6667-20-9.3333-40-14-60Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,807c-2.6667-6.6667-5.3333-13.3333-8-20,2.6667,7,5.3333,14,8,21,.3333,8,.6667,16,1,24v-23c2.3333,3,4.6667,6,7,9-2.3333-3.3333-4.6667-6.6667-7-10,2-7.6667,4-15.3333,6-23-2.3333,7.3333-4.6667,14.6667-7,22Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__middle-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__bg-4",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.2542,488c-22.1469,4.8485-44.2938,9.697-66.4407,14.5455-13.6045,20.6868-27.209,41.3738-40.8136,62.0606,4.113,15.1919,8.226,30.3838,12.339,45.5758,6.3277,6.1414,12.6554,12.2828,18.9831,18.4242l19.9322,8.7273c17.0847,14.2222,34.1695,28.4444,51.2542,42.6667,3.1638-26.505,6.3277-53.0101,9.4915-79.5152-1.5819-37.495-3.1638-74.9899-4.7458-112.4848Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-70)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__shapes_shard_02_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,565c.6667-.3333,1.3333-.6667,2-1,10.3333,.3333,20.6667,.6667,31,1,6.6667,10.3333,13.3333,20.6667,20,31-1.5,9.1667-3,18.3333-4.5,27.5-3.5,1.8333-7,3.6667-10.5,5.5-1.3333,.3333-2.6667,.6667-4,1-6.5-6.1667-13-12.3333-19.5-18.5-4.8333-15.5-9.6667-31-14.5-46.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,482c-1,1.6667-2,3.3333-3,5-26,25.6667-52,51.3333-78,77-.8333,.5-1.6667,1-2.5,1.5-10.8333-.1667-21.6667-.3333-32.5-.5,15-22.3333,30-44.6667,45-67,23.6667-5.3333,47.3333-10.6667,71-16Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,600.5c-.5,.1667-1,.3333-1.5,.5-21.3333-1.3333-42.6667-2.6667-64-4,0,0-.7102-.3551-2-1-6.5-10.1667-13-20.3333-19.5-30.5,27.8333-27.8333,55.6667-55.6667,83.5-83.5,1.1667,39.5,2.3333,79,3.5,118.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,598.5c-.8333,.5-1.6667,1-2.5,1.5-10,12.6667-20,25.3333-30,38-.3333,1.3333-.6667,2.6667-1,4,17.3333,14.6667,34.6667,29.3333,52,44,3.1667-28.5,6.3333-57,9.5-85.5-9.3333-.6667-18.6667-1.3333-28-2Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,642c-.6667-1-1.3333-2-2-3-2.6667-4.6667-5.3333-9.3333-8-14v-2c1.3333-9,2.6667-18,4-27,13.1667,.8333,26.3333,1.6667,39.5,2.5-11.1667,14.5-22.3333,29-33.5,43.5Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,630c4.6667-2.3333,9.3333-4.6667,14-7,3.3333,6.3333,6.6667,12.6667,10,19l-24-12Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-76)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__middle-tiny"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__bg-5",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.5,596.0692c-1.2479,8.5846-2.4957,17.1692-3.7436,25.7538-4.3675,2.2256-8.735,4.4513-13.1026,6.6769-18.7179-6.041-37.4359-12.0821-56.1538-18.1231,8.1111-14.6256,16.2222-29.2513,24.3333-43.8769h30.8846c5.9273,9.8564,11.8547,19.7128,17.7821,29.5692Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-77)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__shapes-shard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,565h-33c-8.6667,15.3333-17.3333,30.6667-26,46l6-3c17.3333-13.6667,34.6667-27.3333,52-41,.3333-.6667,.6667-1.3333,1-2Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,565c6.5,10.1667,13,20.3333,19.5,30.5-.8333,.5-1.6667,1-2.5,1.5-23,4.6667-46,9.3333-69,14h-7c19.6667-15.3333,39.3333-30.6667,59-46Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,630c4.7442-2.1285,9.4884-4.257,14.2327-6.3854-1.0776-.5382-2.1551-1.0764-3.2327-1.6146-20.3333-3.3333-40.6667-6.6667-61-10-3.3333-.3333-6.6667-.6667-10-1,20,6.3333,40,12.6667,60,19Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,595.5c-26.1667,5.1667-52.3333,10.3333-78.5,15.5,24.7442,4.2048,49.4885,8.4097,74.2327,12.6146,.0891-.0382,.1782-.0764,.2673-.1146,1.3333-9.3333,2.6667-18.6667,4-28Z",
    style: {
      fill: "url(#crystal_hero_svg__radial-gradient-81)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_hero_svg__highlights-4",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92,608l24-18c-7.6667,6.3333-15.3333,12.6667-23,19,15.3333-2.6667,30.6667-5.3333,46-8-16.6667,3.3333-33.3333,6.6667-50,10,6.6667-11.6667,13.3333-23.3333,20-35-5.6667,10.6667-11.3333,21.3333-17,32Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCrystalHero);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crystal_hero.feb8f914e5079956e8ae30918f55bf1c.svg";